const RECUPERATORS = [
  {
    url: "https://www.vedinimas.lt/vallox-tsk-multi-50-mv-r-palubinis-plokst-alium-silumokaitis-el-sild-co2-dregmes-jutik-inerneto-modulis-a",
    icon: " https://www.vedinimas.lt/images/uploader/va/588x588.g/vallox-tsk-multi-50-mv-r-palubinis-plokst-alium-silumokaitis-elsild-co2-dregmes-jutik-inerneto-modulis-a-5-1.png",
    code: "003570800",
    name: "Vallox TSK Multi 50 MV ALU",
    range: [50, 150],
    productGroup: "normal",
    ventilatorType: "lubinis",
    good_id: 47172,
  },
  {
    url: "https://www.vedinimas.lt/vallox-tsk-multi-80-mv-r-palubinis-2-sildytuvai-plokst-alium-silumokaitis-co2-dregmes-jutik-inerneto-modulis",
    icon: "https://www.vedinimas.lt/images/uploader/va/588x588.g/vallox-tsk-multi-80-mv-r-palubinis-2-sildytuvai-plokst-alium-silumokaitis-co2-dregmes-jutik-inerneto-modulis-5-1.png",
    code: "003571000",
    name: "Vallox TSK Multi 80 MV ALU",
    range: [150, 250],
    productGroup: "normal",
    ventilatorType: "lubinis",
    good_id: 47174,
  },
  {
    url: "https://www.vedinimas.lt/systemair-save-vsr-150b-r-rotacinis-silumokaitis-desinysis",
    icon: "https://www.vedinimas.lt/images/uploader/sy/588x588.g/systemair-save-vsr-150b-r-rotacinis-silumokaitis-desinysis-3.png",
    code: "000488882",
    name: "Systemair SAVE VSR 150/B ",
    range: [50, 150],
    productGroup: "normal",
    ventilatorType: "lubinis",
    good_id: 47957,
  },
  {
    url: "https://www.vedinimas.lt/systemair-save-vsr-200-b-r-rotacinis-silumokaitis",
    icon: "https://www.vedinimas.lt/images/uploader/sy/588x588.g/systemair-save-vsr-200b-r-rotacinis-silumokaitis-1.png",
    code: "000488863",
    name: "Systemair SAVE VSR 200/B ",
    range: [150, 250],
    productGroup: "normal",
    ventilatorType: "lubinis",
    good_id: 47194,
  },
  {
    url: "https://www.vedinimas.lt/systemair-save-vsr300-rotacinis-silumokaitis",
    icon: "https://www.vedinimas.lt/images/uploader/sy/500x500.g/systemair-save-vsr300-rotacinis-silumokaitis-1.jpg",
    code: "000488802",
    name: "Systemair SAVE VSR 300 ",
    range: [200, 300],
    productGroup: "normal",
    ventilatorType: "lubinis",
    good_id: 46484,
  },
  {
    url: "https://www.vedinimas.lt/systemair-save-vsr400-rotacinis-silumokaitis",
    icon: "https://www.vedinimas.lt/images/uploader/sy/588x588.g/systemair-save-vsr400-rotacinis-silumokaitis-1-1.png",
    code: "000488865",
    name: "Systemair SAVE VSR 400",
    range: [300, 450],
    productGroup: "normal",
    ventilatorType: "lubinis",
    good_id: 47963,
  },
  {
    url: "https://www.vedinimas.lt/systemair-save-vsr500-rotacinis-silumokaitis",
    icon: "https://www.vedinimas.lt/images/uploader/sy/500x500.g/systemair-save-vsr500-rotacinis-silumokaitis-3-1.jpeg",
    code: "000488804",
    name: "Systemair SAVE VSR 500",
    range: [400, 500],
    productGroup: "normal",
    ventilatorType: "lubinis",
    good_id: 46485,
  },
  {
    url: "https://www.vedinimas.lt/systemair-save-vsr-700-rotacinis-silumokaitis",
    icon: "https://www.vedinimas.lt/images/uploader/sy/588x588.g/systemair-save-vsr-700-rotacinis-silumokaitis-3.jpg",
    code: "000488866",
    name: "Systemair SAVE VSR 700",
    range: [500, 700],
    productGroup: "normal",
    ventilatorType: "lubinis",
    good_id: 47978,
  },
  {
    url: "https://www.vedinimas.lt/vallox-051-mv-r-plokstelinis-aliuminio-silumokaitis-el-sildytuvas-co2-dregmes-jutikliai-inerneto-modulis-a-190m3",
    icon: "https://www.vedinimas.lt/images/uploader/va/450x450.g/vallox-51-mv-r-plokstelinis-vertikalus-rekuperatorius-desininis-1.png",
    code: "004106649",
    name: "Vallox 051 MV R ALU",
    range: [50, 150],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 47182,
  },
  {
    url: "https://www.vedinimas.lt/vallox-096-mv-r-plokst-aliuminio-silumokaitis-el-sild-co2-dreg-jutikliai-inerneto-modulis-a-342m3-h-100pa",
    icon: "https://www.vedinimas.lt/images/uploader/va/489x489.g/vallox-096-mv-r-plokst-aliuminio-silumokaitis-elsild-co2-dreg-jutikliai-inerneto-modulis-a-342m3h-100pa-4-1.png",
    code: "003546310",
    name: "Vallox 096 MV R ALU",
    range: [150, 250],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 47160,
  },
  {
    url: "https://www.vedinimas.lt/vallox-99-mv-ra02-plokstelinis-aliuminio-silumokaitis-co2-dregmes-jutiklis-myvallox-cloud-modbus",
    icon: "https://www.vedinimas.lt/images/uploader/va/588x588.g/vallox-99-mv-ra02-plokstelinis-aliuminio-silumokaitis-co2-dregmes-jutiklis-myvallox-cloudmodbus-1-1.png",
    code: "004114424",
    name: "Vallox 99 MV ALU",
    range: [150, 250],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 47184,
  },
  {
    url: "https://www.vedinimas.lt/vallox-99-mv-cf-ra02-plokstelinis-aliuminio-silumokaitis-co2-dregmes-jutiklis-myvallox-cloud-modbus-constant-flow",
    icon: "https://www.vedinimas.lt/images/uploader/va/588x588.g/vallox-99-mv-cf-ra02-plokstelinis-aliuminio-silumokaitis-co2-dregmes-jutiklis-myvallox-cloudmodbus-constant-flow-2.png",
    code: "004116549",
    name: "Vallox 99 MV CF ALU",
    range: [150, 250],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 47180,
  },
  {
    url: "https://www.vedinimas.lt/vallox-110-mv-r-2-sildytuvai-plokst-aliuminio-silumokaitis-co2-dreg-jutikliai-inerneto-modulis",
    icon: "https://www.vedinimas.lt/images/uploader/va/467x467.g/vallox-110-mv-r-2-sildytuvai-plokst-aliuminio-silumokaitis-co2-dreg-jutikliai-inerneto-modulis-5-1.png",
    code: "003546710",
    name: "Vallox 110 MV ALU",
    range: [200, 300],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 47163,
  },
  {
    url: "https://www.vedinimas.lt/vallox-mv-125d-ra02-2-sildytuvai-plokst-aliuminio-silumokaitis-co2-dreg-jutikliai-inerneto-modulis",
    icon: "https://www.vedinimas.lt/images/uploader/va/588x588.g/vallox-mv-125d-ra02-2-sildytuvai-plokst-aliuminio-silumokaitis-co2-dreg-jutikliai-inerneto-modulis-5-1.png",
    code: "004122453",
    name: "Vallox 125 MV ALU",
    range: [250, 350],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 47333,
  },
  {
    url: "https://www.vedinimas.lt/vallox-145-mv-r-2-sildytuvai-plokst-aliuminio-silumokaitis-co2-dreg-jutikliai-inerneto-modulis",
    icon: "https://www.vedinimas.lt/images/uploader/va/479x479.g/vallox-145-mv-r-2-sildytuvai-plokst-aliuminio-silumokaitis-co2-dreg-jutikliai-inerneto-modulis-5-1.png",
    code: "003547110",
    name: "Vallox 145 MV ALU",
    range: [300, 450],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 47167,
  },
  {
    url: "https://www.vedinimas.lt/vallox-245-mv-r-2-sildytuvai-plokst-aliuminio-silumokaitis-co2-dreg-jutikliai-inerneto-modulis",
    icon: "https://www.vedinimas.lt/images/uploader/va/441x441.g/vallox-245-mv-r-plokstelinis-aliuminio-silumokaitis-desinysis-1.png",
    code: "003513120",
    name: "Vallox 245 MV ALU",
    range: [450, 800],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 47158,
  },
  {
    url: "https://www.vedinimas.lt/systemair-save-vtr150-b-r-1000w-rekuperatorius",
    icon: "https://www.vedinimas.lt/images/uploader/sy/500x500.g/systemair-save-vtr150b-r-1000w-rekuperatorius-4-1.jpeg",
    code: "000488818",
    name: "Systemair SAVE VTR 150/B 1000W",
    range: [100, 200],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 46487,
  },
  {
    url: "https://www.vedinimas.lt/systemair-save-vtr-250-b-r-1000w-rekuperatorius",
    icon: "https://www.vedinimas.lt/images/uploader/sy/500x500.g/systemair-save-vtr-250b-r-1000w-rekuperatorius-1.jpg",
    code: "000488822",
    name: "Systemair SAVE VTR 250/B",
    range: [150, 250],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 46489,
  },
  {
    url: "https://www.vedinimas.lt/systemair-save-vtr-275-b-r-rekuperatorius",
    icon: "https://www.vedinimas.lt/images/uploader/sy/588x588.g/systemair-save-vtr-275b-r-rotacinis-sieninis-rekuperatorius-desininis-1.png",
    code: "000488855",
    name: "Systemair SAVE VTR 275/B ",
    range: [150, 250],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 47192,
  },
  {
    url: "https://www.vedinimas.lt/systemair-save-vtr-300-b-r-rotacinis-silumokaitis",
    icon: "https://www.vedinimas.lt/images/uploader/sy/500x500.g/systemair-save-vtr-300b-r-rotacinis-silumokaitis-2-1.jpeg",
    code: "000488826",
    name: "Systemair SAVE VTR 300/B",
    range: [200, 300],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 48074,
  },
  {
    url: "https://www.vedinimas.lt/systemair-save-vtr-500-r-rotacinis-silumokaitis",
    icon: "https://www.vedinimas.lt/images/uploader/sy/500x500.g/systemair-save-vtr-500-r-rotacinis-silumokaitis-1-1.jpg",
    code: "000488830",
    name: "Systemair SAVE VTR 500",
    range: [300, 500],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 46493,
  },
  {
    url: "https://www.vedinimas.lt/systemair-save-vtr-700-r-rotacinis-silumokaitis",
    icon: "https://www.vedinimas.lt/images/uploader/sy/500x500.g/systemair-save-vtr-700-r-rotacinis-silumokaitis-1-1.jpg",
    code: "000488834",
    name: "Systemair SAVE VTR 700",
    range: [500, 800],
    productGroup: "normal",
    ventilatorType: "sieninis",
    good_id: 46495,
  },
  // Premium
  {
    url: "https://www.vedinimas.lt/vallox-tsk-mulsti-50-mv-e-r-palubinis-el-sild-entalpinis-silumokaitis-co2-dregmes-jutik-inerneto-modulis",
    icon: "https://www.vedinimas.lt/images/uploader/va/450x450.g/vallox-tsk-mulsti-50-mv-e-r-palubinis-elsild-entalpinis-silumokaitis-co2-dregmes-jutik-inerneto-modulis-5-1.png",
    code: "003520750",
    name: "Vallox TSK Multi 50 MV-E entalpinis",
    range: [50, 150],
    productGroup: "premium",
    ventilatorType: "lubinis",
    good_id: 47497,
  },
  {
    url: "https://www.vedinimas.lt/vallox-tsk-multi-80-mv-e-r-palubinis-2-sildytuvai-entalpinis-silumokaitis-co2-dregmes-jutik-inerneto-modulis ",
    icon: "https://www.vedinimas.lt/images/uploader/va/500x500.g/vallox-tsk-multi-80mve-r-entalpinis-lubinis-rekuperatorius-desininis-1-1.png",
    code: "003530350",
    name: "Vallox TSK Multi 80 MV-E entalpinis",
    range: [150, 250],
    productGroup: "premium",
    ventilatorType: "lubinis",
    good_id: 46519,
  },
  {
    url: "https://www.vedinimas.lt/vallox-51-mv-re01-entalpinis-silumokaitis-el-sild-co2-dreg-jutikliai-inerneto-modulis-a-185m3-h-100pa",
    icon: "https://www.vedinimas.lt/images/uploader/va/450x450.g/vallox-51-mve-r-entalpinis-vertikalus-rekuperatorius-desininis-2-1.png",
    code: "004113706",
    name: "Vallox 51 MV-E entalpinis",
    range: [50, 150],
    productGroup: "premium",
    ventilatorType: "sieninis",
    good_id: 47344,
  },
  {
    url: "https://www.vedinimas.lt/vallox-096-mv-e-r-entalpinis-silumokaitis-el-sild-co2-dreg-jutikliai-inerneto-modulis-a-342m3-h-100pa",
    icon: "https://www.vedinimas.lt/images/uploader/va/450x450.g/vallox-096-mve-r-entalpinis-vertikalus-rekuperatorius-desininis-2.png",
    code: "003546320",
    name: "Vallox 096 MV-E entalpinis",
    range: [150, 250],
    productGroup: "premium",
    ventilatorType: "sieninis",
    good_id: 46521,
  },
  {
    url: "https://www.vedinimas.lt/vallox-110-mv-e-r-2-sild-entalpinis-silumokaitis-co2-dreg-jutikliai-interneto-modulis",
    icon: "https://www.vedinimas.lt/images/uploader/va/500x500.g/vallox-110-mve-r-entalpinis-vertikalus-rekuperatorius-desininis-2.png",
    code: "003546720",
    name: "Vallox 110 MV-E entalpinis",
    range: [200, 300],
    productGroup: "premium",
    ventilatorType: "sieninis",
    good_id: 46523,
  },
  {
    url: "https://www.vedinimas.lt/vallox-145-mv-e-r-2-sild-entalpinis-silumokaitis-co2-dreg-jutikliai-inerneto-modulis",
    icon: "https://www.vedinimas.lt/images/uploader/va/450x450.g/vallox-145-mve-r-entalpinis-vertikalus-rekuperatorius-desininis-2.png",
    code: "003547120",
    name: "Vallox 145 MV-E entalpinis",
    range: [300, 450],
    productGroup: "premium",
    ventilatorType: "sieninis",
    good_id: 46525,
  },
  {
    url: "https://www.vedinimas.lt/vallox-245-mv-re02-2-sild-entalpinis-silumokaitis-co2-dreg-jutikliai-inerneto-modulis",
    icon: "https://www.vedinimas.lt/images/uploader/va/450x450.g/vallox-245-mve-r-entalpinis-vertikalus-rekuperatorius-desininis-6-1.png",
    code: "003513130",
    name: "Vallox 245 MV-E entalpinis",
    range: [450, 800],
    productGroup: "premium",
    ventilatorType: "sieninis",
    good_id: 47432,
  },
  // Premium+
  {
    url: "https://www.vedinimas.lt/myvallox-51-cfi-re01-entalpinis-vedinimo-irenginys-150-m3h-150-pa",
    icon: "https://www.vedinimas.lt/images/uploader/my/588x588.g/myvallox-51-cfi-re01-entalpinis-vedinimo-irenginys-150-m3h-150-pa-constant-flow-4-1.png?t=342797",
    code: "004128158",
    name: "MyVallox 51 CFi RE01 entalpinis vėdinimo įrenginys 150 m3/h 150 Pa. Constant-Flow",
    range: [50, 150],
    productGroup: "premium_plus",
    ventilatorType: "sieninis",
    good_id: 48164,
  },
  {
    url: "https://www.vedinimas.lt/myvallox-99-cfi-re02-entalpinis-vedinimo-irenginys-300-m3h-250-pa",
    icon: "https://www.vedinimas.lt/images/uploader/my/588x588.g/myvallox-99-cfi-re02-entalpinis-vedinimo-irenginys-300-m3h-250-pa-constant-flow-8-1.png?t=780929",
    code: "004128108",
    name: "MyVallox 99 CFi RE02 entalpinis vėdinimo įrenginys 300 m3/h 250 Pa Constant-Flow 	",
    range: [150, 250],
    productGroup: "premium_plus",
    ventilatorType: "sieninis",
    good_id: 48162,
  },
  {
    url: "https://www.vedinimas.lt/myvallox-119-cfi-xe02-entalpinis-vedinimo-irenginys-400-m3h-300-pa",
    icon: "https://www.vedinimas.lt/images/uploader/my/445x445.g/myvallox-119-cfi-xe02-entalpinis-vedinimo-irenginys-400-m3h-300-pa-1.png?t=63892",
    code: "004122611",
    name: "MyVallox 119 CFi XE02 entalpinis vėdinimo įrenginys 400 m3/h 300 Pa Constant-Flow",
    range: [250, 350],
    productGroup: "premium_plus",
    ventilatorType: "sieninis",
    good_id: 48158,
  },
  {
    url: "https://www.vedinimas.lt/myvallox-149-cfi-xe02-entalpinis-vedinimo-irenginys-500-m3h-300-pa",
    icon: "https://www.vedinimas.lt/images/uploader/my/445x445.g/myvallox-149-cfi-xe02-entalpinis-vedinimo-irenginys-500-m3h-300-pa-7-1.png?t=429062",
    code: "004122614",
    name: "MyVallox 149 CFi XE02 entalpinis vėdinimo įrenginys 500 m3/h 300 Pa Constant-Flow",
    range: [350, 450],
    productGroup: "premium_plus",
    ventilatorType: "sieninis",
    good_id: 48160,
  },
  {
    url: "https://www.vedinimas.lt/myvallox-245-cfi-re02-entalpinis-vedinimo-irenginys-800-m3h-200-pa",
    icon: "https://www.vedinimas.lt/images/uploader/my/588x588.g/myvallox-245-cfi-re02-entalpinis-vedinimo-irenginys-800-m3h-200-pa-constant-flow-7.png?t=353530",
    code: "004128166",
    name: "MyVallox 245 CFi RE02 entalpinis vėdinimo įrenginys. 800 m3/h 200 Pa. Constant-Flow",
    range: [450, 800],
    productGroup: "premium_plus",
    ventilatorType: "sieninis",
    good_id: 48167,
  },
  {
    url: "https://www.vedinimas.lt/valsir-ariosa-hv-170-entalpic-palubinis-rekuperatorius-su-pulteliu-universalus",
    icon: "https://www.vedinimas.lt/images/uploader/va/882x882.g/valsir-ariosa-hv-170-entalpic-palubinis-rekuperatorius-su-pulteliu-universalus-5.jpg?t=221139",
    code: "000430811",
    name: "Valsir Ariosa HV 170 Enthalpic palubinis rekuperatorius su pulteliu ir elektriniu šildytuvu. Universalus",
    range: [50, 150],
    productGroup: "premium_plus",
    ventilatorType: "lubinis",
    good_id: 48172,
  },
  {
    url: "https://www.vedinimas.lt/valsir-ariosa-hv-250-entalpic-palubinis-rekuperatorius-su-pulteliu-universalus",
    icon: "https://www.vedinimas.lt/images/uploader/va/945x945.g/valsir-ariosa-hv-250-enthalpic-palubinis-rekuperatorius-su-pulteliu-universalus-7-1.png?t=694462",
    code: "000430813",
    name: "Valsir Ariosa HV 250 Enthalpic palubinis rekuperatorius su pulteliu ir elektriniu šildytuvu. Universalus",
    range: [150, 200],
    productGroup: "premium_plus",
    ventilatorType: "lubinis",
    good_id: 48173,
  },
  {
    url: "https://www.vedinimas.lt/valsir-ariosa-hv-330-entalpic-palubinis-rekuperatorius-su-pulteliu-universalu",
    icon: "https://www.vedinimas.lt/images/uploader/va/945x945.g/valsir-ariosa-hv-330-enthalpic-palubinis-rekuperatorius-su-pulteliu-universalu-6-1.png?t=410466",
    code: "000430815",
    name: "Valsir Ariosa HV 330 Enthalpic palubinis rekuperatorius su pulteliu ir elektriniu šildytuvu. Universalus",
    range: [200, 300],
    productGroup: "premium_plus",
    ventilatorType: "lubinis",
    good_id: 48174,
  }
];

export default RECUPERATORS;
